import type { Messages } from './en';

const tr: Partial<Messages> = {
  'lang.label': 'Dil',
  'nav.tracker': 'Sipariş Takibi',
  'nav.robux': 'Robux Siparişi',
  'common.loading': 'Siparişin yükleniyor…',
  'common.order': 'Sipariş #{id}',
  'common.submit': 'Gönder',

  'landing.title': 'Siparişini takip et',
  'landing.sub': 'Teslimat durumunu canlı görmek için sipariş numaranı gir',
  'landing.header': 'Sipariş numaran',
  'landing.label': 'Sipariş numarası',
  'landing.placeholder': 'Sipariş numaranı gir',
  'landing.btn': 'Siparişi takip et',

  'terms.title': 'Devam etmeden önce',
  'terms.intro': 'Siparişine devam etmek için lütfen aşağıdaki maddeleri okuyup kabul et.',
  'terms.p1': '<b>Girdiğin hesaptan sen sorumlusun.</b> Hesap sistemimize girdiği anda transfer otomatik olarak yapılır; bu yüzden doğru hesap olduğundan emin ol — sonrasında coinleri başka yere yönlendiremeyiz.',
  'terms.p2': '<b>Tüm süreç otomatiktir.</b> Hızı, hızlı ya da yavaş, değiştirilemez ve kontrol edilemez — sistemimiz bir EA tespit sistemiyle senkronize çalışır; süreç güvenli görüldüğü sürece devam eder, güvenli değilse durur.',
  'terms.p3': '<b>EA vergisini (%{pct}) biz karşılamıyoruz.</b> {gross}K coin sipariş ettin, bu yüzden net <b>{net}K coin</b> alacaksın.',
  'terms.p4': '<b>Transferde bir sorun olursa önce siparişini takip eden yetkiliyle konuş.</b> Hemen anlaşmazlık açma — bu işi hızlandırmaz, sadece çözümü zorlaştırır.',
  'terms.agree': 'Yukarıdakilerin hepsini okudum ve kabul ediyorum',
  'terms.accept': 'Kabul ediyorum — devam',
  'terms.decline': 'Kabul etmiyorum',
  'terms.declinedTitle': 'Sorun değil',
  'terms.declinedBody': 'Sorun değil — hesabında hiçbir işlem başlatılmadı. Anlaşılmayan bir madde varsa siparişini takip eden yetkiliye sor. Hazır olduğunda bu sayfaya dönüp devam edebilirsin.',
  'terms.back': 'Geri dön',

  'tax.hero': '{gross}K satın alındı · kulübüne {net}K ulaşır',
  'tax.noteTitle': 'EA her coin satışından %{pct} keser',
  'tax.noteBody': '<b>{gross}K coin</b> satın aldın. EA\'nın %{pct} transfer vergisini biz karşılamıyoruz, bu yüzden kulübüne <b>{net}K coin</b> ulaşacak — siparişinin karşıladığı miktar budur.',
  'tax.finished': 'Kulübüne <b>{net}K coin</b> ulaştı ({gross}K satın alındı, EA\'nın %{pct} vergisi düşüldü).',

  'hero.loading': 'Yükleniyor…',
  'hero.notFound': 'Sipariş bulunamadı',
  'hero.unknown': 'Bilinmiyor',
  'hero.cancelled': 'Sipariş iptal edildi',
  'hero.awaiting': 'Bilgilerin bekleniyor',
  'hero.delivered': 'Başarıyla teslim edildi!',
  'hero.dailyLimit': 'Günlük limite ulaşıldı',
  'hero.no2fa': 'Giriş doğrulamasını etkinleştir',
  'hero.newBA': 'Yeni yedek kod gerekli',
  'hero.wrongPass': 'Giriş bilgileri hatalı',
  'hero.processing': 'İşleniyor',
  'hero.paused': 'Sipariş duraklatıldı',
  'hero.delivering': 'Coinlerin teslim ediliyor',
  'badge.cancelled': 'İPTAL',
  'badge.action': 'İŞLEM GEREKLİ',
  'badge.complete': 'TAMAMLANDI',
  'badge.autoResume': 'YARIN OTOMATİK DEVAM EDER',
  'badge.support': 'DESTEKLE İLETİŞİME GEÇ',
  'badge.retry': 'OTOMATİK YENİDEN DENEME',
  'badge.progress': 'DEVAM EDİYOR',
  'hero.pct': '%{pct} teslim edildi · {ordered}K coinin {delivered}K\'sı',
  'hero.refresh': 'Yenile',

  'msg.notFound': 'Sipariş bulunamadı',
  'msg.netRetry': 'Ağ hatası — yeniden deneniyor…',
  'msg.submitFail': 'Gönderilemedi. Lütfen tekrar dene.',
  'msg.net': 'Ağ hatası. Lütfen tekrar dene.',
  'msg.resumed': 'Sipariş devam ettirildi! Durum yenileniyor…',
  'msg.waitLogout': 'Çıkış yaptıktan sonra biraz bekle, sonra tekrar dene.',
  'msg.cantResumeWhy': 'Şu an devam ettirilemiyor — {reason}. Otomatik olarak devam edecek.',
  'msg.cantResume': 'Şu an devam ettirilemiyor — siparişin otomatik olarak devam edecek. Birazdan tekrar dene.',
  'msg.resumeFail': 'Devam ettirilemedi. Lütfen destekle iletişime geç.',
  'msg.retrying': 'Yeniden deneniyor! Durum yenileniyor…',
  'msg.retryFail': 'Yeniden deneme başarısız — birazdan tekrar dene.',
  'msg.cancelledTitle': 'Bu sipariş iptal edildi.',
  'msg.cancelledBody': 'Bunun bir hata olduğunu düşünüyorsan siparişini hazırlayan kişiyle iletişime geç.',

  'pending.banner': '<b>{platform}</b> platformu için <b>{amount}K coin</b> siparişin hazır. Teslimatı başlatmak için aşağıya EA hesap bilgilerini gir. Bilgilerin güvenli şekilde iletilir ve asla saklanmaz.',
  'pending.header': 'EA hesap bilgilerin',
  'pending.logout': '<b>Göndermeden önce:</b> tüm cihazlarda EA uygulamasından, FUT Web App\'ten ve yardımcı uygulamadan çıkış yap.',
  'pending.email': 'EA hesabı e-postası',
  'pending.emailPh': 'sen@email.com',
  'pending.password': 'EA hesabı şifresi',
  'pending.passwordPh': 'EA şifren',
  'pending.ba1': 'Yedek kod #1',
  'pending.ba1Hint': '— EA güvenlik ayarlarından',
  'pending.ba1Ph': 'örn. 12345678',
  'pending.ba2': 'Yedek kod #2',
  'pending.ba3': 'Yedek kod #3',
  'pending.optional': '— isteğe bağlı',
  'pending.hideExtra': '− Ek kodları gizle',
  'pending.showExtra': '+ Daha fazla yedek kod ekle (önerilir)',
  'pending.start': 'Teslimatı başlat',
  'pending.starting': 'Teslimat başlatılıyor…',
  'pending.locked': 'Devam etmek için lütfen şartları okuyup kabul et.',
  'pending.reopenTerms': 'Şartları tekrar gözden geçir',

  'active.delivered': 'Coinlerin teslim edildi! ⚽',
  'active.thanks': '911GamingStore\'u seçtiğin için teşekkürler. İyi oyunlar!',
  'active.stayOut': 'Siparişin aktifken tüm cihazlarda EA uygulamasından, FUT Web App\'ten ve yardımcı uygulamadan <b>çıkış yapmış halde kal</b>.',
  'active.meta': ' · 100K başına ~10 dk · Günlük limit: 1–3M coin (ertesi gün otomatik devam eder)',
  'active.dailyHeader': 'Günlük transfer limitine ulaşıldı',
  'active.dailyBody': 'Bugünkü günlük transfer limitine ulaşıldı. Bu normal bir koruma önlemidir — siparişin yarın otomatik olarak devam edecek. Senin bir şey yapmana gerek yok. Giriş yapıp normal oynayabilir, istersen coinleri harcayabilirsin — sipariş ~30 saat içinde otomatik devam eder. Aşağıdaki düğmeyle kalan süreyi görebilirsin. Sabrın için teşekkürler 👍',
  'active.retryBtn': 'Düzelttim — Tekrar dene',
  'active.retrying': 'Yeniden deneniyor…',
  'metric.ordered': 'Sipariş',
  'metric.willReceive': 'Alacağın',
  'metric.delivered': 'Teslim edilen',
  'metric.remaining': 'Kalan',
  'progress.title': 'Teslimat ilerlemesi',
  'progress.starting': 'Başlıyor…',
  'progress.inProgress': 'Devam ediyor',
  'progress.complete': 'Tamamlandı',

  'ba.titleNo2fa': 'Giriş doğrulamasını etkinleştir ve yedek kod gir',
  'ba.titleNew': 'Yeni yedek kod gerekli',
  'ba.descNo2fa': 'EA hesabında giriş doğrulaması kurulu değil. Önce etkinleştir, ardından yedek kodlar oluştur ve aşağıya birini gir:',
  'ba.descNew': 'Yedek kodun yanlış veya süresi dolmuş. Şu adımları izle, sonra aşağıya yeni bir kod gir:',
  'ba.no2faSteps': '<b>account.ea.com</b> → Güvenlik → Giriş Doğrulaması bölümüne git\nDoğrulamayı etkinleştir — Kimlik Doğrulama Uygulaması veya E-posta seç\nEtkinleştirdikten sonra <b>Yedek Kodlar</b> bölümüne gidip yeni bir set oluştur\nYeni kodlardan birini kopyalayıp aşağıya gir',
  'ba.newSteps': '<b>account.ea.com</b> → Güvenlik → Giriş Doğrulaması → Yedek Kodlar bölümüne git\nYeni bir yedek kod seti oluştur\nYeni kodlardan birini kopyalayıp aşağıya gir',
  'ba.placeholder': 'Yeni yedek kod',
  'ba.ok': 'Yedek kod güncellendi! Siparişin yeniden deneniyor…',
  'ba.fail': 'Başarısız. Kodu kontrol et veya destekle iletişime geç.',
  'cred.title': 'Giriş bilgilerini güncelle',
  'cred.desc': 'E-posta veya şifre değişmiş görünüyor. Bilgilerini aşağıda kontrol edip güncelle:',
  'cred.steps': '<b>account.ea.com</b> adresine gidip e-posta ve şifrenin doğru olduğunu kontrol et\nŞifreni yakın zamanda değiştirdiysen yenisini aşağıya gir\nGöndermeden önce tüm EA uygulamalarından çıkış yaptığından emin ol',
  'cred.emailPh': 'EA hesabı e-postası (değiştiyse)',
  'cred.passPh': 'Yeni EA hesabı şifresi',
  'cred.ok': 'Bilgiler güncellendi! Siparişin yeniden deneniyor…',
  'cred.fail': 'Güncellenemedi. Lütfen destekle iletişime geç.',
  'resume.title': 'Sipariş duraklatıldı — hazır olunca devam et',
  'resume.desc': 'Siparişin duraklatıldı. Tüm EA uygulamalarından çıkış yaptığından emin ol, sonra Devam Et\'e tıkla.',
  'resume.btn': 'Siparişi devam ettir',
  'resume.busy': 'Devam ettiriliyor…',
  'cool.title': 'Kalan süreyi kontrol et',
  'cool.btn': 'Beklemeyi kontrol et',
  'cool.busy': 'Kontrol ediliyor…',
  'cool.desc': 'Günlük transfer limitinin sıfırlanmasına ve siparişinin otomatik devam etmesine ne kadar kaldığını kontrol et.',
  'cool.ready': 'Limit sıfırlandı! Siparişin birazdan devam edecek.',
  'cool.hm': 'Yaklaşık {h} sa {m} dk kaldı',
  'cool.min': 'Yaklaşık {m} dk kaldı',
  'shot.before': 'Hesap kanıtı (önce)',
  'shot.latest': 'Son transfer kanıtı',
  'shot.none': 'Henüz mevcut değil',
  'row.status': 'Durum',
  'row.accountCheck': 'Hesap kontrolü',
  'row.economy': 'Ekonomi durumu',
  'row.balance': 'Hesap bakiyesi',
  'row.created': 'Sipariş oluşturuldu',
  'row.coins': '{n} coin',


  // ── Shop with us (replaces the old promo) + footer ─────────
  'shop.eyebrow': 'FC coinden fazlası',
  'shop.title': 'Oynadığın her şey. Tek mağaza.',
  'shop.lede': 'Oyun yüklemeleri, hediye kartları ve oyun anahtarları net ve düşük fiyatlarla — otomatik teslimat, 7/24.',
  'shop.from': '{price}\'dan başlayan',
  'shop.floor': 'Fiyatlar {price}\'dan başlıyor',
  'shop.browse': 'Hepsine göz at',
  'shop.cta': '911 Gaming Store\'dan alışveriş yap',
  'shop.pay': 'Ödeme yöntemleri',
  'shop.f1t': 'Düşük ve net fiyatlar',
  'shop.f1d': 'Ödemeden önce tam fiyatı görürsün — sürpriz yok.',
  'shop.f2t': 'Otomatik teslimat',
  'shop.f2d': 'Siparişlerin çoğu gece gündüz kendiliğinden ulaşır.',
  'shop.f3t': 'Önce hesap güvenliği',
  'shop.f3d': 'Giriş bilgilerin asla saklanmaz.',
  'shop.f4t': 'Gerçek destek, 7/24',
  'shop.f4d': 'Bot değil insanlar, sipariş tamamlanana kadar yanında.',
  'shop.cat.game-top-ups': 'Oyun yüklemeleri',
  'shop.cat.gift-cards': 'Hediye kartları',
  'shop.cat.game-keys': 'Oyun anahtarları',
  'footer.desc': 'Net fiyatlar, hızlı teslimat ve her sipariş tamamlanana kadar yanında olan gerçek bir destek ekibiyle oyun yüklemeleri, hediye kartları ve oyun anahtarları.',
  'footer.shop': 'Mağaza',
  'footer.help': 'Yardım',
  'footer.track': 'Sipariş takibi',
  'footer.contact': 'Destekle iletişime geç',

  'err.wrongPersona.t': 'Yanlış persona seçili',
  'err.wrongPersona.d': 'Hesabında yanlış FUT personası seçili.',
  'err.wrongPersona.s': 'www.ea.com/fifa/ultimate-team/web-app adresinden FUT Web App\'i aç\nProfil simgene tıklayıp doğru FUT personasına geç\nTüm cihaz ve tarayıcılardan tamamen çıkış yap',
  'err.captcha.t': 'CAPTCHA doğrulaması gerekli',
  'err.captcha.d': 'EA hesabın için güvenlik kontrolü istiyor.',
  'err.captcha.s': 'www.ea.com/fifa/ultimate-team/web-app adresinden FUT Web App\'i aç\nGiriş yap ve istenirse CAPTCHA doğrulamasını tamamla\nTamamen çıkış yap',
  'err.wrongUserPass.t': 'Giriş bilgileri hatalı',
  'err.wrongUserPass.d': 'Girdiğin e-posta veya şifre yanlış ya da gönderdikten sonra değişmiş.',
  'err.wrongUserPass.s': 'EA hesabının e-posta ve şifresinin hâlâ doğru olduğunu kontrol et\nGerekirse şifreni account.ea.com adresinden sıfırla\nBilgilerini güncellemesi için siparişini hazırlayan kişiye haber ver',
  'err.wrongBA.t': 'Yedek kod yanlış',
  'err.wrongBA.d': 'Yedek kodun yanlış veya daha önce kullanılmış.',
  'err.wrongBA.s': 'account.ea.com → Güvenlik → Giriş Doğrulaması → Yedek Kodlar bölümüne git\nYeni bir yedek kod seti oluştur\nYeni kodlardan birini aşağıdaki forma gir',
  'err.No2FA.t': 'Giriş doğrulaması (2FA) kurulu değil',
  'err.No2FA.d': 'EA hesabında giriş doğrulaması etkin değil. Transferin çalışması için gereklidir.',
  'err.No2FA.s': 'account.ea.com → Güvenlik → Giriş Doğrulaması bölümüne git\nDoğrulamayı etkinleştir — Kimlik Doğrulama Uygulaması veya E-posta seç\nEtkinleştirdikten sonra Yedek Kodlar bölümüne gidip yeni bir set oluştur\nYeni kodlardan birini aşağıdaki forma gir',
  'err.noTM.t': 'Web App Transfer Pazarı erişimi yok',
  'err.noTM.d': 'Bu EA hesabı FUT Web App\'teki Transfer Pazarı\'nı kullanamıyor. Bu, oyun içindeki Transfer Pazarı değil — ikisi ayrıdır, yani oyunda çalışıp Web App\'te kilitli kalabilir.',
  'err.noTM.s': 'www.ea.com/fifa/ultimate-team/web-app adresinden FUT Web App\'i aç ve Transfers → Transfer Market\'e git\nOrada kilitliyse veya erişilemiyorsa, FUT eğitimini tamamla ve EA hesabında açana kadar maç oynamaya devam et\nGerekliyse EA Play / EA Pro aboneliğinin aktif olduğunu kontrol et\nSiparişin açık kalır — Web App Transfer Pazarı çalışınca siparişini hazırlayan kişiye haber ver, transfer devam eder',
  'err.tlFull.t': 'Transfer listesi dolu',
  'err.tlFull.d': 'FUT transfer listen tam dolu ve yeni transferleri engelliyor.',
  'err.tlFull.s': 'Telefonunda FUT Web App\'i veya EA uygulamasını aç\nTransferler → Transfer Listesi bölümüne git\nEn az 5 yer açmak için bazı öğeleri sat veya kaldır\nTamamen çıkış yap',
  'err.receiverTLFull.t': 'Transfer listen dolu',
  'err.receiverTLFull.d': 'Transfer listende yer kalmadı — yer açana kadar hesabına coin gönderilemez.',
  'err.receiverTLFull.s': 'www.ea.com/fifa/ultimate-team/web-app adresinden FUT Web App\'i aç\nTransferler → Transfer Listesi bölümüne git\nEn az 5 yer açmak için öğeleri sat veya Quick Sell yap\nTüm EA uygulamalarından ve tarayıcılardan tamamen çıkış yap',
  'err.FailedReceiverDeviceBan.t': 'Hesabın EA tarafından işaretlendi',
  'err.FailedReceiverDeviceBan.d': 'EA hesabına cihaz seviyesinde bir engel koydu. Müdahale gerekiyor.',
  'err.FailedReceiverDeviceBan.s': 'EA hesabına giriş yapma — siparişini hazırlayan kişiye hemen haber ver',
  'err.FailWebAppNotYetUnlocked.t': 'FUT Web App henüz açılmadı',
  'err.FailWebAppNotYetUnlocked.d': 'EA hesabın, transferler için gerekli olan FUT Web App\'i henüz açmadı.',
  'err.FailWebAppNotYetUnlocked.s': 'Konsolunda veya PC\'nde FIFA/EA FC\'yi aç\nFUT eğitimini tamamla ve en az birkaç maç oyna\nFUT Web App\'e erişebildiğinde siparişini hazırlayan kişiye haber ver',
  'err.FailWebAppCustomerLocked.t': 'FUT Web App oturumun kilitli',
  'err.FailWebAppCustomerLocked.d': 'EA hesabının web oturumu şu an kilitli — genellikle başka bir cihazda oturum açık olduğu için.',
  'err.FailWebAppCustomerLocked.s': 'www.ea.com/fifa/ultimate-team/web-app adresindeki FUT Web App\'ten çıkış yap\nTelefonundaki ve diğer tüm cihazlardaki EA uygulamasından çıkış yap\n5 dakika bekle, sonra tekrar dene',
  'err.calcErrorMaintenance.t': 'EA geçici bakımda',
  'err.calcErrorMaintenance.d': 'EA şu an bakımda — otomatik olarak yeniden deneniyor. İşlem gerekmiyor.',
  'err.noPlayer.t': 'Uygun transfer aranıyor (yeniden deneniyor)',
  'err.noPlayer.d': 'Şu an uygun oyuncu kartı bulunamadı — otomatik olarak yeniden deneniyor.',
  'err.safetyHold.t': 'Güvenli bir transfer zamanı bekleniyor',
  'err.safetyHold.d': 'Sistemimiz, EA\'nın transfer izleme sisteminin ne zaman aktif olduğunu ve pazardaki tüm coin hareketlerini taradığını algılar. Şu anda yoğun bir aktivite gösteriyor, bu yüzden transferini güvenliğin için beklemeye aldık. Bu durum hesabını değil, tüm pazarı ilgilendiriyor. EA\'nın sistemi sakinleşir sakinleşmez siparişin otomatik olarak devam eder. Senin bir şey yapmana gerek yok.',
  'err.belowMinTransfer.t': 'Transfer minimum tutarın altında',
  'err.belowMinTransfer.d': 'Kalan tutar minimum transfer eşiğinin altında. Daha küçük bir transferle devam etmek için devam ettirebilirsin.',
  'err.belowMinTransfer.s': 'Kalan tutarla teslimata devam etmek için aşağıdaki Devam Et\'e tıkla',
  'err.notEnoughCoins.t': 'Hesapta yeterli coin yok',
  'err.notEnoughCoins.d': 'Transferlerin işlenmesi için hesabında en az 10.000 coin olmalı.',
  'err.notEnoughCoins.s': 'Hesabında coin olması için Transfer Pazarı\'ndan ucuz bir oyuncu al\nEn az 10.000 coinin olunca aşağıdaki Tekrar Dene\'ye tıkla',
  'err.unassignedItemsPresent.t': 'Atanmamış öğeler var',
  'err.unassignedItemsPresent.d': 'Hesabında, transferlerin devam edebilmesi için atanması gereken öğeler var.',
  'err.unassignedItemsPresent.s': 'FUT Web App\'i veya EA uygulamasını aç\nKulüp → Atanmamış Öğeler bölümüne git\nTüm öğeleri kulübüne veya transfer listene taşı\nTamamen çıkış yap',
  'err.console.t': 'Konsolda hâlâ Ultimate Team\'desin',
  'err.console.d': 'Hesabın PlayStation veya Xbox\'ta Ultimate Team\'de aktif.',
  'err.console.s': 'Konsolunda FIFA/EA FC\'yi açıp Ultimate Team\'e git\nOptions/Start → Ana Menüye Çık\'a bas (oyunu sadece kapatma)\nOyunun Ultimate Team\'den tamamen çıkmasını bekle',
  'err.loginFailed.t': 'Giriş başarısız — her yerden çıkış yap',
  'err.loginFailed.d': 'EA girişi reddetti; büyük olasılıkla hesabın başka bir cihazda veya tarayıcıda aktif.',
  'err.loginFailed.s': 'Tüm telefon ve tabletlerde EA uygulamasından çıkış yap\nwww.ea.com/fifa/ultimate-team/web-app adresindeki FUT Web App\'ten çıkış yap\nKullanıyorsan FIFA/FC yardımcı uygulamasından çıkış yap',
  'err.LoginFailedDeviceBan.t': 'Giriş EA tarafından engellendi',
  'err.LoginFailedDeviceBan.d': 'EA, sistemimizden girişi engelledi. Ekibimizin müdahale etmesi gerekiyor.',
  'err.LoginFailedDeviceBan.s': 'EA hesabına kendin giriş yapma — siparişini hazırlayan kişiye hemen haber ver',
  'err.FailedSessionExpiredCustomerLoggedIn.t': 'Şu an EA uygulamasında oturumun açık',
  'err.FailedSessionExpiredCustomerLoggedIn.d': 'Hesabın başka bir cihazda EA uygulamasında veya web\'de aktif.',
  'err.FailedSessionExpiredCustomerLoggedIn.s': 'www.ea.com/fifa/ultimate-team/web-app adresindeki FUT Web App\'ten çıkış yap\nTelefonundaki EA uygulamasından çıkış yap\nFIFA/FC yardımcı uygulamasından çıkış yap',
  'err.FailLoggedInConsoleTo.t': 'Şu an EA uygulamasında oturumun açık',
  'err.FailLoggedInConsoleTo.d': 'Hesabın başka bir cihazda veya tarayıcıda aktif.',
  'err.FailLoggedInConsoleTo.s': 'Tüm cihazlarda FUT Web App\'ten ve EA uygulamasından çıkış yap',
  'err.FailedProxyConnectionError.t': 'Geçici teknik sorun',
  'err.FailedProxyConnectionError.d': 'Bizim tarafımızda kısa süreli bir teknik sorun — otomatik olarak yeniden deneniyor. İşlem gerekmiyor.',
  'err.FailedProxyPoolExhausted.t': 'Geçici ağ sorunu',
  'err.FailedProxyPoolExhausted.d': 'Bizim tarafımızda kısa süreli bir ağ sorunu — otomatik olarak yeniden deneniyor. İşlem gerekmiyor.',
  'err.FailedCouldNotStartTo.t': 'Transfer başlatılıyor (yeniden deneniyor)',
  'err.FailedCouldNotStartTo.d': 'Transferi başlatırken anlık bir sorun yaşandı — otomatik olarak yeniden deneniyor.',
  'err.noClub.t': 'FUT kulübü bulunamadı',
  'err.noClub.d': 'EA hesabında aktif bir FUT kulübü yok — kulüp olmadan coin alınamaz.',
  'err.noClub.s': 'FIFA/EA FC\'yi açıp Ultimate Team\'i başlat\nİlk FUT kurulumunu tamamla ve en az bir maç oyna\nFUT kulübün kurulunca siparişini hazırlayan kişiye haber ver',
  'err.wrongConsole.t': 'Platform uyuşmazlığı',
  'err.wrongConsole.d': 'Siparişindeki platform EA hesabınla uyuşmuyor.',
  'err.wrongConsole.s': 'Siparişini hazırlayan kişiye haber ver — platformu düzeltmesi gerekiyor',
  'err.daily.t': 'Günlük transfer limitine ulaşıldı',
  'err.senderTempban.t': 'Tedarikçi geçici olarak duraklatıldı',
  'err.senderTempban.d': 'Tedarikçi hesabımızda kısa bir EA bekleme süresi var. Otomatik olarak ele alınıyor — işlem gerekmiyor.',
  'err.transfersInProgress.t': 'Transfer devam ediyor',
  'err.transfersInProgress.d': 'Transferler aktif olarak işleniyor — kısa süre içinde güncellenecek.',

  'status.pending': 'Beklemede',
  'status.ready': 'Hazır',
  'status.entered': 'Girildi',
  'status.waitingForAssignment': 'Atama bekleniyor',
  'status.active': 'Aktif',
  'status.finished': 'Bitti',
  'status.interrupted': 'Kesintiye uğradı',
  'status.tempbanCooldown': 'Bekleme süresi',
  'status.cancelled': 'İptal edildi',
  'status.completed': 'Tamamlandı',

  'rbx.heroLine': '{gross} R$ game pass · sana {net} R$ ulaşır',
  'rbx.hero.pass': 'Game pass\'ini gönder',
  'rbx.hero.done': 'Robux teslim edildi!',
  'rbx.hero.delivering': 'Robux\'ların teslim ediliyor',
  'rbx.hero.retrying': 'Yeniden deneniyor',
  'rbx.notFoundTitle': 'Bu siparişi bulamadık',
  'rbx.createTitle': '{gross} R$ fiyatlı bir game pass oluştur',
  'rbx.taxIntro': 'Roblox her game pass satışından %{pct} keser; bu yüzden <b>{gross} R$</b> fiyatlı bir pass <b>{net} R$</b> öder — hesabına ulaşacak miktar budur ve siparişinin karşıladığı miktar da budur.',
  'rbx.steps': 'Roblox\'u aç → <b>Create</b> → sahip olduğun herhangi bir oyunu seç\n<b>Associated Items → Passes</b> bölümüne gidip bir pass oluştur\nPass\'i aç → <b>Configure → Sales</b>\n<b>Item for Sale</b>\'i aç ve fiyatı tam olarak <b>{gross} R$</b> yap\nAşağıdan gönder — pass bağlantısı, sadece ID\'si veya Roblox kullanıcı adın',
  'rbx.reqTitle': 'Game pass\'in şu kurallara da uymalı',
  'rbx.req': '<b>Managed / Regional Pricing</b> kapalı (OFF) olmalı\nİçerik derecelendirme anketinde tüm sorulara <b>No</b> yanıtını ver\nOyun <b>Public</b> olmalı (gizliyse: Archive → Restore → Make Public)\nRoblox hesabın <b>yaş doğrulamalı (16+)</b> olmalı',
  'rbx.videoBtn': 'Game pass\'i nasıl oluşturacağını bilmiyor musun? Video rehberi izle',
  'rbx.tabPass': 'Pass bağlantısı veya ID',
  'rbx.tabUser': 'Roblox kullanıcı adı',
  'rbx.passLabel': 'Game pass bağlantısı veya ID',
  'rbx.passPh': 'https://www.roblox.com/game-pass/000000000/…  veya sadece 000000000',
  'rbx.reading': 'Game pass <b>#{id}</b> okunuyor ✓',
  'rbx.badPaste': 'Bu henüz bir game pass bağlantısı ya da ID\'sine benzemiyor — bağlantının tamamını veya yalnızca içindeki rakamları yapıştır.',
  'rbx.userLabel': 'Roblox kullanıcı adı',
  'rbx.userPh': 'Robux\'u alacak hesap',
  'rbx.userHint': 'Pass\'i hesabında kendimiz bulacağız. Yine de fiyatı tam <b>{gross} R$</b> olmalı, satışta olmalı ve herkese açık oyunlarından birinde bulunmalı.',
  'rbx.placeLabel': 'Oyun / yer ID\'si',
  'rbx.placePh': 'Yalnızca birden fazla oyunun varsa',
  'rbx.sendPass': 'Game pass\'imi gönder',
  'rbx.sendUser': 'Kullanıcı adımı gönder',
  'rbx.sending': 'Gönderiliyor…',
  'rbx.allSet': 'Hazırsın — yapman gereken başka bir şey yok',
  'rbx.sentDone': '<b>{net} R$</b> Roblox hesabına gönderildi{user}.',
  'rbx.sentWait': 'Game pass\'ini aldık ve siparişin bizim tarafımızda tamamlandı. <b>{net} R$</b> Roblox hesabına doğru yolda.',
  'rbx.holdTitle': 'Harcamak neden 5–7 gün sürüyor',
  'rbx.holdBody1': 'Roblox, <em>her</em> game pass satışının kazancını kullanılabilir hale gelmeden önce bir bekleme süresi boyunca tutar. Robux\'ların önce hesabında <b>beklemede</b> görünür, sonra <b>5–7 gün</b> içinde harcanabilir olur.',
  'rbx.holdBody2': 'Roblox tüm game pass satın alımlarında böyle çalışır — biz ya da başkası hızlandıramaz. Siparişin tamamlandı.',
  'rbx.favourTitle': 'Küçük bir ricamız var',
  'rbx.favourBody': 'Her şey doğruysa lütfen siparişi Eldorado\'da <b>teslim alındı</b> olarak işaretle ve bir yorum bırak. Küçük bir ekibiz ve bu bizim için gerçekten çok önemli. 🙏',
  'rbx.eldoradoBtn': 'Eldorado\'da onayla ve değerlendir',
  'rbx.passOnFile': 'Kayıtlı game pass:',
  'rbx.passLabelShort': 'Game pass:',
  'rbx.providerDown': 'Canlı durum kısa süre için kullanılamıyor — siparişin etkilenmiyor.',
  'rbx.tryAgain': 'Tekrar dene',
  'rbx.retrying': 'Yeniden deneniyor…',
  'rbx.cancelledTitle': 'Bu sipariş iptal edildi',
  'rbx.cancelledBody': 'Bunun bir hata olduğunu düşünüyorsan siparişini hazırlayan kişiyle iletişime geç.',
  'rbx.msg.noAccept': 'Bu bağlantıyı kabul edemedik',
  'rbx.msg.net': 'Sunucuya ulaşılamadı. Bağlantını kontrol et.',
  'rbx.msg.retryWait': 'Şu an yeniden denenemiyor — bir dakika sonra tekrar dene.',
  'rbx.msg.retryOk': 'Yeniden deneniyor — bu sayfa kendiliğinden güncellenir.',

  'rbxi.gamepass_not_found.t': 'Game pass\'ini henüz göremiyoruz',
  'rbxi.gamepass_not_found.d': 'Roblox pass\'i yayınlamamış olabilir veya bağlantıyı gönderdikten sonra silinmiş ya da adı değişmiş olabilir. Kendimiz kontrol etmeye devam ediyoruz; yeni oluşturulan bir pass genellikle birkaç dakika içinde fark edilir.',
  'rbxi.gamepass_not_found.s': 'Game pass sayfanı aç ve hâlâ var olduğunu doğrula\nFiyatın yukarıda gösterilen tutarla tam olarak aynı olduğundan emin ol\nPass\'in satışta (On Sale) olduğunu kontrol et\nSonra aşağıdaki Tekrar Dene\'ye bas',
  'rbxi.insufficient_customer_balance.t': 'Siparişin sırada',
  'rbxi.insufficient_customer_balance.d': 'Bakiye yüklüyoruz ve siparişin otomatik olarak işlenecek. Senden bir şey gerekmiyor.',
  'rbxi.unknown_error.t': 'Siparişin bir deneme daha gerektiriyor',
  'rbxi.unknown_error.d': 'Teslimatı bir şey kesintiye uğrattı. Bunları otomatik olarak yeniden deniyoruz — sen de kendin yeniden deneyebilirsin.',
  'rbxi.GAMEPASS_NOT_FOUND.t': 'Bu game pass bulunamadı',
  'rbxi.GAMEPASS_NOT_FOUND.d': 'Roblox\'ta bu bağlantıda bir pass yok. Yeni oluşturulan pass\'lerin görünmesi bir dakika sürebilir.',
  'rbxi.GAMEPASS_NOT_FOUND.s': 'Bağlantıyı kendin aç ve pass\'in yüklendiğini kontrol et\nPass açıkken bağlantıyı tarayıcı adres çubuğundan kopyala\nYeni oluşturduysan bir dakika bekle, sonra tekrar gönder',
  'rbxi.GAMEPASS_PRICE_MISMATCH.t': 'Pass fiyatı siparişinle uyuşmuyor',
  'rbxi.GAMEPASS_PRICE_MISMATCH.d': 'Game pass\'in fiyatı yukarıda gösterilen tutarla tam olarak aynı olmalı — alacağın tutarla değil.',
  'rbxi.GAMEPASS_PRICE_MISMATCH.s': 'Game pass\'ini aç → Configure → Sales\nFiyatı yukarıda gösterilen tutara tam olarak ayarla\nKaydet, sonra bağlantıyı tekrar gönder',
  'rbxi.REGIONAL_PRICING_NOT_SUPPORTED.t': 'Bu pass\'te bölgesel fiyatlandırma açık',
  'rbxi.REGIONAL_PRICING_NOT_SUPPORTED.d': 'Roblox farklı ülkelerde farklı fiyat gösterir; bu yüzden pass sabit bir tutarla satın alınamaz.',
  'rbxi.REGIONAL_PRICING_NOT_SUPPORTED.s': 'Game pass\'ini aç → Configure → Sales\nRegional Pricing\'i kapat\nKaydet, sonra bağlantıyı tekrar gönder',
  'rbxi.GAMEPASS_SELLER_MISMATCH.t': 'Bu pass başka bir hesaba ait',
  'rbxi.GAMEPASS_SELLER_MISMATCH.d': 'Game pass, Robux\'u alacak aynı Roblox hesabında oluşturulmalı.',
  'rbxi.GAMEPASS_SELLER_MISMATCH.s': 'Pass\'i Robux\'u alacak hesapta oluştur\nYeni bağlantıyı gönder',
  'rbxi.UNIVERSE_NOT_FOUND.t': 'Bu pass\'in bağlı olduğu oyunu okuyamadık',
  'rbxi.UNIVERSE_NOT_FOUND.d': 'Pass\'in herkese açık bir oyuna ait olması gerekir.',
  'rbxi.UNIVERSE_NOT_FOUND.s': 'Oyununu aç → Configure → Public olduğundan emin ol\nSonra bağlantıyı tekrar gönder',
  'rbxi.ROBLOX_USER_NOT_FOUND.t': 'Bu Roblox hesabını bulamadık',
  'rbxi.ROBLOX_USER_NOT_FOUND.d': 'Kullanıcı adının yazımını kontrol et veya bunun yerine game pass bağlantını gönder.',
  'rbxi.ROBLOX_USER_NOT_FOUND.s': 'Game pass bağlantısını gönder — hesabını kendiliğinden tanımlar',
  'rbxi.OUT_OF_STOCK.t': 'Siparişin kuyrukta',
  'rbxi.OUT_OF_STOCK.d': 'Robux stoğu yenileniyor ve siparişin ayrıldı. Stok olur olmaz otomatik tamamlanır — yapman gereken bir şey yok.',
  'rbxi.ROBLOX_DAILY_LIMIT.t': 'Roblox günlük limitine ulaşıldı',
  'rbxi.ROBLOX_DAILY_LIMIT.d': 'Roblox, bir hesaba günde gönderilebilecek miktarı sınırlar. Limit sıfırlanınca siparişin otomatik olarak devam eder.',
  'rbxi.INSUFFICIENT_FUNDS.t': 'Siparişin sırada',
  'rbxi.INSUFFICIENT_FUNDS.d': 'Siparişin ayrıldı ve kısa süre içinde tamamlanacak. Senden bir şey gerekmiyor.',
  'rbxi.ORDER_ALREADY_EXISTS.t': 'Bu sipariş zaten işleniyor',
  'rbxi.ORDER_ALREADY_EXISTS.d': 'Game pass\'in zaten elimizde — tekrar göndermene gerek yok.',
};

export default tr;
